module.exports = __webpack_public_path__ + "img/SA.f553f484.jpg";